
import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-[#1a2a4a] via-[#1e3a5f] to-[#0f1f3a] flex flex-col items-center justify-center px-4 relative overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none">
        <div className="absolute top-20 left-10 w-72 h-72 bg-[#c9a227]/10 rounded-full blur-3xl"></div>
        <div className="absolute bottom-20 right-10 w-96 h-96 bg-[#c9a227]/5 rounded-full blur-3xl"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] bg-[#1e3a5f]/50 rounded-full blur-3xl"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 text-center max-w-lg">
        {/* 404 Number */}
        <div className="mb-6">
          <h1 className="text-[150px] md:text-[180px] font-black text-transparent bg-clip-text bg-gradient-to-b from-[#c9a227] to-[#8b7019] leading-none select-none">
            404
          </h1>
        </div>

        {/* Icon */}
        <div className="w-20 h-20 mx-auto mb-6 bg-[#c9a227]/20 rounded-full flex items-center justify-center">
          <i className="ri-compass-discover-line text-4xl text-[#c9a227]"></i>
        </div>

        {/* Message */}
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-3">
          Page Not Found
        </h2>
        <p className="text-gray-300 text-base md:text-lg mb-8 leading-relaxed">
          Oops! The page you're looking for doesn't exist or has been moved. 
          Let's get you back on track.
        </p>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-gradient-to-r from-[#c9a227] to-[#b8922a] text-[#1a2a4a] font-semibold rounded-lg hover:from-[#d4ad2e] hover:to-[#c9a227] transition-all duration-300 shadow-lg shadow-[#c9a227]/20 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-home-4-line text-lg"></i>
            Back to Home
          </Link>
          <button
            onClick={() => window.history.back()}
            className="inline-flex items-center justify-center gap-2 px-8 py-3.5 bg-white/10 text-white font-semibold rounded-lg hover:bg-white/20 transition-all duration-300 border border-white/20 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-lg"></i>
            Go Back
          </button>
        </div>

        {/* Help text */}
        <p className="mt-10 text-gray-400 text-sm">
          Need assistance? Visit our{" "}
          <Link to="/" className="text-[#c9a227] hover:underline cursor-pointer">
            Process Catalogue
          </Link>{" "}
          to find what you're looking for.
        </p>
      </div>

      {/* Footer branding */}
      <div className="absolute bottom-6 text-center">
        <p className="text-gray-500 text-xs">
          University Process Catalogue
        </p>
      </div>
    </div>
  );
}
